export default "__VITE_ASSET__CEuVaUnf__"